"use client"

import React from "react";
import { FormattedMessage, useIntl } from "react-intl";
import Image from "next/image";
import { FaInstagram, FaWhatsapp, FaFacebook, FaLinkedin } from "react-icons/fa6";

import Logo from "@/assets/images/logo/logo_white.svg";

const socialContent = [
  {
    icon: <FaWhatsapp style={{ fontSize: 25, color: "#ffffff" }} />,
    link: "https://wa.me/message/AFY5MLYSZMFIG1",
    label: "Open the website whatsapp",
  },
  {
    icon: <FaInstagram style={{ fontSize: 25, color: "#ffffff" }} />,
    link: "https://www.instagram.com/downfor.life/",
    label: "Open the website instagram profile",
  },
  {
    icon: <FaFacebook style={{ fontSize: 25, color: "#ffffff" }} />,
    link: "https://www.facebook.com/downfor.webapp/",
    label: "Open the website instagram profile",
  },
  {
    icon: <FaLinkedin style={{ fontSize: 25, color: "#ffffff" }} />,
    link: "https://www.linkedin.com/company/downfor",
    label: "Open the website instagram profile",
  }
];

const Footer = () => {
  const intl = useIntl();

  return (
    <div className="col">
      <div className="row justify-content-center align-items-center">
        <div className="col-lg-4">
          <div className="logo">
            <a
              href="https://www.downfor.life/"
              aria-label="Go to home page"
              title="Downfor App Store app"
            >
              <Image
                src={Logo}
                width={30}
                height={30}
                alt="The Downfor Logo"
                title="Downfor Logo"
              />
            </a>
          </div>
        </div>

        <div className="col-lg-4">
          <div className="title">
            <FormattedMessage id="home-page-footer-title" />
          </div>
          <ul className="d-flex justify-content-evenly align-items-center g-4">
            {socialContent.map((val, i) => (
              <li key={i}>
                <a
                  href={val.link}
                  target="_blank"
                  rel="noreferrer"
                  className="d-flex justify-content-center align-items-center"
                  aria-label={val.label}
                  title={`Downfor link to ${val.label}`}
                >
                  {val.icon}
                </a>
              </li>
            ))}
          </ul>
        </div>

        <div className="col-lg-4">
          <div className="text-center">
            <a
              href="mailto:hello@downfor.life"
              className="email"
              title={`Send an email`}
            >
              hello@downfor.life
            </a>
          </div>
        </div>
      </div>
      <div className="term-of-use-container">
        <a
          href="https://www.downfor.life/privacy-policy"
          aria-label={intl.formatMessage({ id: "login-page-privacy-policy" })}
          title={`Link to ${intl.formatMessage({ id: "login-page-privacy-policy" })}`}
        >
          <FormattedMessage id="login-page-privacy-policy" />
        </a>
        <a
          href="https://www.downfor.life/terms-of-service"
          aria-label={intl.formatMessage({ id: "login-page-term-of-use" })}
          title={`Link to ${intl.formatMessage({ id: "login-page-term-of-use" })}`}
        >
          <FormattedMessage id="login-page-term-of-use" />
        </a>
        <a
          href="https://www.downfor.life/cookies-policy"
          aria-label={intl.formatMessage({ id: "login-page-cookies-policy" })}
          title={`Link to ${intl.formatMessage({ id: "login-page-cookies-policy" })}`}
        >
          <FormattedMessage id="login-page-cookies-policy" />
        </a>
      </div>
    </div>
  );
};

export default Footer;
